import { BUSINESS, waLink } from "@/data/site";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Footer() {
  return (
    <footer
      className="relative z-10 border-t border-white/10 bg-black"
      data-testid="footer"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-20">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-6">
            <div className="font-display text-4xl sm:text-5xl font-light tracking-tighter">
              V.S.V. Agencies
            </div>
            <p className="mt-5 max-w-md text-white/50 leading-relaxed">
              Authorised dealers & distributors of DOWSIL silicone sealants,
              Chennai Express urad dhal and Wopper laundry chemicals — serving
              businesses and households across Tamil Nadu.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="overline mb-5">Explore</div>
            <ul className="space-y-3">
              {[
                ["Products", "products"],
                ["Pricing", "pricing"],
                ["About", "about"],
                ["Contact", "contact"],
              ].map(([label, id]) => (
                <li key={id}>
                  <button
                    onClick={() => scrollTo(id)}
                    className="text-white/60 transition-colors hover:text-white"
                    data-testid={`footer-link-${id}`}
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="overline mb-5">Reach us</div>
            <ul className="space-y-3 text-white/60">
              <li>
                <a
                  href={`mailto:${BUSINESS.email}`}
                  className="hover:text-white"
                  data-testid="footer-email"
                >
                  {BUSINESS.email}
                </a>
              </li>
              <li>
                <a
                  href={waLink()}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white"
                  data-testid="footer-whatsapp"
                >
                  {BUSINESS.phoneDisplay}
                </a>
              </li>
              <li>
                {BUSINESS.city}, {BUSINESS.state}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 text-sm text-white/40 md:flex-row md:items-center">
          <span>
            © {new Date().getFullYear()} V.S.V. Agencies. All rights reserved.
          </span>
          <span>DOWSIL™ is a trademark of The Dow Chemical Company.</span>
        </div>
      </div>
    </footer>
  );
}
